import moment from 'moment-timezone'

export function isAfterMinDate(minDate: Date) {
  return (date: string | null | undefined) => {
    if (!date) return false
    return moment(date, 'DD/MM/YYYY').isAfter(minDate)
  }
}
